import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
import MarketsAPIUtils from 'utils/MarketsAPIUtils';
import MarketAPIUtils from 'utils/MarketAPIUtils';

const ActionTypes = AdminConstants.ActionTypes;

export default {
  getAllMarkets() {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.MARKETS_FETCH,
    });
  },
  getMarket(id) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.MARKET_FETCH,
      id,
    });
  },
  findMarket(coords) {
    AdminAppDispatcher.handleViewAction({
      type: ActionTypes.FIND_MARKET,
      coords,
    });
  },
  findMarkets(query={}) {
    MarketAPIUtils.getMarkets(query);
  },
  updateMarket(id, updates) {
    MarketAPIUtils.updateMarket(id, updates);
  },
  createMarket(market) {
    MarketAPIUtils.createMarket(market);
  },
};
